(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "./constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("./constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.constants);
    global.selectors = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createIsLoadingSelector = createIsLoadingSelector;
  _exports.createErrorMessageSelector = createErrorMessageSelector;

  function createIsLoadingSelector(asyncActionTypes) {
    return (state, id) => {
      return asyncActionTypes.some(asyncActionType => {
        const baseType = extractBaseType(asyncActionType);
        const requestStateKey = !(0, _ramda.isNil)(id) ? `${baseType}_${id}` : baseType;
        return (0, _ramda.path)([_constants.MODULE_NAMESPACE, requestStateKey, _constants.LOADING_STATE_KEY], state);
      });
    };
  }

  function extractBaseType(asyncActionType) {
    const {
      request
    } = asyncActionType;
    const actionTypeMatch = /(.*)_(.*)/.exec(request);
    const [, baseType] = actionTypeMatch;
    return baseType;
  }

  function createErrorMessageSelector(asyncActionType, {
    unique
  }) {
    return (state, id) => {
      const baseType = extractBaseType(asyncActionType);
      const requestStateKey = unique ? `${baseType}_${id}` : baseType;
      return (0, _ramda.path)([_constants.MODULE_NAMESPACE, requestStateKey, _constants.ERROR_MESSAGE_KEY], state);
    };
  }
});